<template>
    <div class="bo-search-number">
        <input
            :id="id"
            :field="column.id"
            :placeholder="generalTranslations.search ?? 'Search'"
            class="search-input"
            type="text"
            :value="searchString"
            @click="showPopup($event)"
            ref="input"
            readonly
        />
        <div
            v-if="popupVisibility"
            v-click-outside="hidePopup"
            class="bo-context-menu"
            :style="menuStyles"
            ref="contextMenu"
        >
            <div class="context-search">
                <vue-numeric
                    :minus="column.sign"
                    :placeholder="generalTranslations.from ?? 'From'"
                    :precision="column.decimal"
                    :field="column.id"
                    class="context-number"
                    v-model="column.search[0]"
                ></vue-numeric>

                <i class="icon-date-separator"></i>

                <vue-numeric
                    :minus="column.sign"
                    :placeholder="generalTranslations.to ?? 'To'"
                    :precision="column.decimal"
                    :field="column.id"
                    class="context-number"
                    v-model="column.search[1]"
                ></vue-numeric>
            </div>
            <div class="context-button">
                <button
                    class="btn-rounded mr-1 resetButton"
                    @click="resetRange"
                >
                    {{ generalTranslations.reset ?? "Reset" }}
                </button>
                <button
                    class="btn-rounded ml-1 applyButton"
                    @click="updateNumberRange"
                >
                    {{ generalTranslations.apply ?? "Apply" }}
                </button>
            </div>
        </div>
        <!-- <Portal to="popup-section">
        </Portal> -->
        <!-- <Portal to="popup-section">
            <div
                v-if="popupVisibility"
                v-click-outside="hidePopup"
                class="bo-context-menu"
                :style="menuStyles"
            >
                <div class="bo-range-slider">
                    <vue-slider
                        ref="range1"
                        :contained="true"
                        :max="column.meta.max"
                        :min="column.meta.min"
                        :value="column.search"
                        v-model="column.search"
                    />

                    <div class="bo-slider-input">
                        <vue-numeric
                            :minus="column.sign"
                            :precision="column.decimal"
                            :field="column.id"
                            :class="`form-control slider-start`"
                            v-model="column.search[0]"
                        ></vue-numeric>

                        <vue-numeric
                            :minus="column.sign"
                            :precision="column.decimal"
                            :field="column.id"
                            :class="`form-control slider-end`"
                            v-model="column.search[1]"
                        ></vue-numeric>
                    </div>
                </div>

                <div class="filter-footer d-flex justify-content-between">
                    <button
                        class="btn-rounded transparent danger"
                        @click="resetRange"
                    >
                        Reset
                    </button>

                    <div class="buttons d-flex">
                        <button
                            class="btn-rounded light"
                            @click="hidePopup"
                        >
                            Cancel
                        </button>
                        <button
                            class="btn-rounded success ml-2"
                            @click="updateNumberRange"
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </Portal> -->
    </div>
</template>

<script>
import Vue from "vue";
import vClickOutside from "v-click-outside";
import VueNumeric from "vue-numeric";
import VueSlider from "vue-slider-component";
Vue.use(vClickOutside);
import UniqueId from "vue-unique-id";
Vue.use(UniqueId);
import PortalVue from "portal-vue";
Vue.use(PortalVue);

export default {
    props: ["id", "column", "parentId", "rightPos"],

    components: {
        VueNumeric,
        VueSlider,
    },

    data() {
        return {
            popupVisibility: false,
            menuPosition: { x: 0, y: 0 },
            menuHeight: null,
            menuWidth: null,
            generalTranslations: window.bo?.generalTranslations ?? {},
        };
    },

    computed: {
        searchString() {
            if (
                (this.column.search[0] == null && this.column.search[1] == null) ||
                (this.column.search[0] == "" && this.column.search[1] == "")
            ) {
                return null;
            }
            return this.column.search[0] + " to " + this.column.search[1];
        },
        menuStyles() {
            return {
                top: `75px`,
                right: this.rightPos ? `0px` : ``,
                position: "absolute",
                display: "block",
            };
        },
        isMenuBeyondRightEdge() {
            const screenWidth = window.innerWidth;
            console.log(screenWidth);
            return this.menuPosition.x + this.menuWidth > screenWidth;
        },
        isMenuBeyondBottomEdge() {
            const screenHeight = window.innerHeight;
            console.log(screenHeight);
            return this.menuPosition.y + this.menuHeight > screenHeight;
        },
    },

    created() {
        // window.addEventListener("resize", this.setPopupPosition);
        // window.addEventListener("scroll", this.setPopupPosition);
        // let parent = this.$parent;
        // while (parent && typeof parent.$el !== "undefined") {
        //     parent.$el.addEventListener("scroll", this.setPopupPosition);
        //     parent = parent.$parent;
        // }
        // this component needs a [from, to] range, but the shared Column model only
        // declares `search` as a bare (undefined) field — initialize it before indexing in
        if (!Array.isArray(this.column.search)) {
            this.column.search = [];
        }
        this.column.search[0] = "";
        this.column.search[1] = "";
    },

    methods: {
        setPopupPosition() {
            var elem_position = this.$refs["input"].getBoundingClientRect();
            // this.top = elem_position.y + elem_position.height + 5;
            // this.left = elem_position.x;
            this.menuPosition.x = elem_position.x;
            this.menuPosition.y = elem_position.y + elem_position.height + 12;
        },

        showPopup(e) {
            e.preventDefault();
            if (!this.popupVisibility) {
                this.setPopupPosition();
                this.popupVisibility = true;
            }
            this.$forceUpdate();
        },

        hidePopup(event) {
            // const isOutsideMenu = !event.target.closest(".bo-context-menu");
            // if (isOutsideMenu) {
            //     this.popupVisibility = false;
            // }
            if (this.id != event.target.id) {
                this.popupVisibility = false;
            }
            this.$forceUpdate();
        },

        resetRange() {
            this.column.search = [this.column.min, this.column.max];
        },

        updateNumberRange() {
            this.popupVisibility = false;
            this.$emit("updateSearch", this.column.search);
        },
    },
};
</script>
